import { combineReducers, createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import {
  attributeCreateReducer,
  attributeDeleteReducer,
  attributeGetReducer,
  attributeListReducer,
  atttributeUpdateReducer,
} from "./reducers/attributeReducers";
import {
  brandDeleteReducer,
  brandGetReducer,
  brandListReducer,
  brandUpdateReducer,
  createBrandReducer,
} from "./reducers/brandReducers";
import { cartReducer } from "./reducers/cartReducers";
import {
  categoryDeleteReducer,
  categoryGetReducer,
  categoryListReducer,
  categoryUpdateReducer,
  createCategoryReducer,
} from "./reducers/categoryReducers";
import {
  orderCreateReducer,
  orderDeleteReducer,
  orderGetReducer,
  orderListReducer,
  orderPayReducer,
  orderUpdateReducer,
} from "./reducers/orderReducers";
import {
  storeCreateReducer,
  storeDeleteReducer,
  storeGetReducer,
  storeListReducer,
  storeUpdateReducer,
} from "./reducers/storeRedcuers";
import {
  productCreateReducer,
  productDeleteReducer,
  productGetReducer,
  productListReducer,
  productUpdateReducer,
} from "./reducers/storeReducers";
import { themeChangeReducer } from "./reducers/themeReducer";
import {
  userLoginReducer,
  userRegisterReducer,
  userUpdateReducer,
} from "./reducers/userReducers";

const reducer = combineReducers({
  // reducers
  createBrand: createBrandReducer,
  brandList: brandListReducer,
  brandGet: brandGetReducer,
  brandUpdate: brandUpdateReducer,
  brandDelete: brandDeleteReducer,
  userRegister: userRegisterReducer,
  userLogin: userLoginReducer,
  userUpdate: userUpdateReducer,
  categoryList: categoryListReducer,
  categoryGet: categoryGetReducer,
  categoryUpdate: categoryUpdateReducer,
  categoryDelete: categoryDeleteReducer,
  categoryCreate: createCategoryReducer,
  attributeList: attributeListReducer,
  attributeGet: attributeGetReducer,
  attributeCreate: attributeCreateReducer,
  attributeUpdate: atttributeUpdateReducer,
  attributeDelete: attributeDeleteReducer,
  storeList: storeListReducer,
  storeGet: storeGetReducer,
  storeCreate: storeCreateReducer,
  storeUpdate: storeUpdateReducer,
  storeDelete: storeDeleteReducer,
  productCreate: productCreateReducer,
  productList: productListReducer,
  productDelete: productDeleteReducer,
  productGet: productGetReducer,
  productUpdate: productUpdateReducer,
  orderGet: orderGetReducer,
  orderCreate: orderCreateReducer,
  orderUpdate: orderUpdateReducer,
  orderDelete: orderDeleteReducer,
  orderList: orderListReducer,
  cart: cartReducer,
  themeChange: themeChangeReducer,
  orderPay: orderPayReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = {
  userLogin: {
    userInfo: userInfoFromStorage,
  },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
